import React, { Component } from 'react'
import { Link, Navigate } from 'react-router-dom'
import "./Header.css"
import Navbar1 from './Navbar1'
import NavBar2 from './NavBar2'

export class Header extends Component {
  state = {
    coverTitle: "HomePage",
    logout: false
  }

  logoutHandler = () => {

    this.props.setLoggedOut();
    this.setState({ logout: true })
  }

  render() {
    return (
      <>
     

        {/* <nav class="navbar navbar-expand-lg bg-light">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <Link class="navbar-brand" to="/">Navbar</Link>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <Link class="nav-link active" aria-current="page" to="/">Home</Link>
        </li>
        <li class="nav-item">
          <Link class="nav-link" to="/teachers">Teachers</Link>
        </li>

        <li class="nav-item">
          <Link class="nav-link" to="/department">Department</Link>
        </li>
        <li class="nav-item">
          <Link class="nav-link disabled">Disabled</Link>
        </li>
      </ul>
      <form class="d-flex" role="search">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
        <button class="btn btn-outline-success" type="submit">Search</button>
      </form>
    </div>
  </div>
</nav> */}

     <NavBar2 logoutHandler={this.logoutHandler}/>
     {/* <Navbar1/> */}














      </>
    )
  }
}

export default Header